import { Controller } from 'stimulus'
import { ANSWERED_VALUE, visibleKeys } from '../../components/blueprints/conditions'

const ANSWER_NAME = /\[field_answers_attributes\]\[[^\]]+\]\[(\w+)\](\[\])?$/
const NOT_ANSWERS = ['id', 'field_id', 'section_id', '_destroy']
const HIDDEN_ITEM = '[data-target~="blueprints--conditions.item"].d-none'

// A hidden field is not required, so it never blocks the form
export default class extends Controller {
  static targets = ['item']

  connect() {
    this.refresh = this.refresh.bind(this)
    // Removing a photo is only a click: the cards change after it
    this.refreshLater = (event) => setTimeout(() => this.refresh(event), 0)
    this.element.addEventListener('input', this.refresh)
    this.element.addEventListener('change', this.refresh)
    this.element.addEventListener('click', this.refreshLater)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener('input', this.refresh)
    this.element.removeEventListener('change', this.refresh)
    this.element.removeEventListener('click', this.refreshLater)
  }

  refresh(event) {
    if (!this.items || this.items.length !== this.itemTargets.length) {
      this.items = this.itemTargets.map((element) => ({
        element,
        key:        element.dataset.key,
        fieldId:    parseInt(element.dataset.fieldId, 10),
        sectionKey: element.dataset.sectionKey || null,
        condition:  element.dataset.condition ? JSON.parse(element.dataset.condition) : null,
        inCopy:     element.dataset.inCopy === 'true',
        values:     element.dataset.section ? [] : this.valuesOf(element),
        visible:    null
      }))
    } else if (event && event.target && event.target.closest) {
      const element = event.target.closest('[data-key]')
      const item = element && this.items.find((candidate) => candidate.element === element)
      if (item && !item.element.dataset.section) { item.values = this.valuesOf(item.element) }
    } else {
      this.items.forEach((item) => { if (!item.element.dataset.section) { item.values = this.valuesOf(item.element) } })
    }

    const visible = visibleKeys(this.items)
    this.items.forEach((item) => {
      const shown = visible.has(item.key)
      if (item.visible === shown) { return }
      item.visible = shown
      this.toggle(item.element, shown)
    })
  }

  valuesOf(element) {
    if (this.hasPhoto(element)) { return [ANSWERED_VALUE] }

    const values = []
    element.querySelectorAll('input, select, textarea').forEach((input) => {
      if ((input.name || '').includes('pictures_attributes')) { return }
      const match = (input.name || '').match(ANSWER_NAME)
      if (!match || NOT_ANSWERS.includes(match[1])) { return }
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) { return }

      let value = input.value
      if (match[1] === 'checkbox_answer') { value = { on: 'true', off: 'false' }[value] || value }
      if (value === 'choose_extra_option') { value = 'extra_option' }
      if (match[1] === 'signature_answer' || match[1] === 'table_answer') { value = value ? ANSWERED_VALUE : '' }
      if (value !== '') { values.push(value) }
    })
    return values
  }

  hasPhoto(element) {
    return Array.from(element.querySelectorAll('.custom-form-photos__photo-card')).some((card) => {
      if (card.style.display === 'none') { return false }
      const destroy = card.querySelector('input[name$="[_destroy]"]')
      if (destroy && ['1', 'true'].includes(destroy.value)) { return false }
      const file = card.querySelector('input[type="file"]')
      return file ? file.files.length > 0 : true
    })
  }

  toggle(element, visible) {
    element.classList.toggle('d-none', !visible)
    element.querySelectorAll('[required], [data-conditionally-required]').forEach((input) => {
      if (!visible && input.required) {
        input.dataset.conditionallyRequired = 'true'
        input.required = false
      } else if (visible && input.dataset.conditionallyRequired && !input.closest(HIDDEN_ITEM)) {
        input.required = true
        delete input.dataset.conditionallyRequired
      }
    })
  }
}
